import { I18NextPipe } from 'angular-i18next';
import { TableHeader } from 'mbs-ui-kit';

export const tagHeaders = [
  {
    name: '',
    sort: 'name',
    gridColSize: '3fr',
    isGridColumn: false
  }
];

export const rmmIntersectionHeaders = (i18nPipe: I18NextPipe): TableHeader[] => [
  {
    name: i18nPipe.transform('mbs-ui:rmm-custom-alerting.page.table.name'),
    class: 'w-100',
    gridColSize: '10fr',
    gridColMin: '80px',
    isGridColumn: false
  },
  {
    name: i18nPipe.transform('mbs-ui:rmm-custom-alerting.page.table.priorityLevel'),
    class: 'w-100',
    gridColSize: '10fr',
    gridColMin: '80px',
    isGridColumn: false
  }
];
